import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 340px;
  text-align: center;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(5)} ${theme.spacing(5)}`};
  box-sizing: content-box;
`;

export const IconWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  font-size: 25px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-weight: 700;
`;

export const TextArea = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;
